import * as action from "../actions/index";
import { baseUrl } from "./config";

export const getCategories = () => async dispatch => {
  try {
    const result = await fetch(`${baseUrl}/categories/`);

    if (!result.ok) {
      throw { error: true };
    }

    const data = await result.json();
    dispatch(action.fetchCategories(data));
  } catch (error) {
    console.log(error);
  }
};

export const getSubcategories = async categoryId => {
  console.log("getSubcategories");

  try {
    const result = await fetch(`${baseUrl}/categories/${categoryId}`);

    if (!result.ok) {
      throw { error: true };
    }

    const data = await result.json();
    return data.subcategories;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const getCategories = () => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  var category_list = [];
  var subcategories = [];
  const firestore = getFirestore();
  firestore
    .collection("categories")
    .orderBy("name")
    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        const item = doc.data();
        //console.log(doc.ref);

        if (item.parentCategoryId === "NULL")
          category_list.push({ category: item, ref: doc.ref });
        else subcategories.push({ category: item, ref: doc.ref });
        // console.log(doc.id, " => ", doc.data());
      });
      dispatch(action.fetchCategories(category_list));
      dispatch(action.fetchSubcategories(subcategories));
    })
    .catch(function(error) {
      console.log("Error getting documents: ", error);
    });
}; */

export const getGroups = () => async dispatch => {
  try {
    const result = await fetch(`${baseUrl}/groups/`);

    if (!result.ok) {
      throw { error: true };
    }

    const data = await result.json();
    dispatch(action.fetchGroups(data));
  } catch (error) {
    console.log(error);
  }
};

/* export const getGroups = () => (dispatch, getState, { getFirebase, getFirestore }) => {
    var groups = []
    const firestore = getFirestore()
    firestore.collection("groups")
    .orderBy('name')
    .get()
    .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            const item = doc.data()
            groups.push({ref: doc.ref, data: item});
        });
        //console.log(groups);
        
        dispatch(action.fetchGroups(groups));
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
} */

/* export const getSubcategories = (categoryId) => (dispatch, getState, { getFirebase, getFirestore }) => {
    var category_list = []
    const firestore = getFirestore()
    firestore.collection("categories").where('parentCategoryId', '==', categoryId)
    .get()
    .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            category_list.push({category:doc.data(), ref: doc.ref})
            // console.log(doc.id, " => ", doc.data());
        });
        dispatch(action.fetchSubcategories(category_list))
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
} */
